import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { Paper, Tab, Tabs, Typography } from '@mui/material';
import { DummyScrollButton } from '../GeneralSettings/GeneralSettingsTabs';
import { sharedStyles } from '../../utils/Style';

type DiscountAtCheckoutTab = 'products' | 'settings';

type DiscountAtCheckoutTabsProps = {
  selectedTab: DiscountAtCheckoutTab;
};

export const DiscountAtCheckoutTabs = (props: DiscountAtCheckoutTabsProps) => {
  const navigate = useNavigate();

  const handleChange = useCallback((_: any, i: number) => {
    navigate(
      `/sales/at-checkout-discount/${i === 0 ? 'products' : 'settings'}`,
    );
  }, []);

  return (
    <Paper>
      <Tabs
        variant='scrollable'
        value={props.selectedTab === 'products' ? 0 : 1}
        onChange={handleChange}
        ScrollButtonComponent={DummyScrollButton}
      >
        <Tab
          label={<Typography sx={sharedStyles.tabLabel}>Ürünler</Typography>}
        />
        <Tab
          label={<Typography sx={sharedStyles.tabLabel}>Ayarlar</Typography>}
        />
      </Tabs>
    </Paper>
  );
};
